import { useParams } from 'react-router-dom';

import ParticipantImportCompare from './ParticipantImportCompare';
import ParticipantImportList from './ParticipantImportList';

// The competition_participant_import Screen: the list of imports, or one
// import's comparison at /apps/<app>/competition_participant_import/compare/<id>
// (same shape as the student import).
const ParticipantImport = () => {
  const { operation, id } = useParams<{ operation?: string; id?: string }>();
  return operation === 'compare' && id ? (
    <ParticipantImportCompare importId={Number(id)} />
  ) : (
    <ParticipantImportList />
  );
};

export default ParticipantImport;
